<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-toolbar flat color="white">
      <v-toolbar-title>Questions</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.question" label="Question"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="editedItem.question_type_id" 
                    :items="indexData.uiCategories" 
                    item-text="name" 
                    item-value="id"
                    box label="Question Type"
                    ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.question_variable" label="Question Variable"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.required_optional" label="Required/Optional"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.multiple_answer" label="Multiple Ans(y/n)"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.measurement_settings" label="Measurement Settings"></v-text-field>
                    </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.checkbox_multiple" label="Checkbox Multiple(y/n)"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.question }}</td>
        <td class="text-xs-center">{{ props.item.question_types.ui_category_id }}</td>
        <td class="text-xs-center">{{ props.item.question_variable }}</td>
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center">{{ props.item.required_optional }}</td>
        <td class="text-xs-center">{{ props.item.multiple_answer }}</td>
        <td class="text-xs-center">{{ props.item.measurement_settings }}</td>
        <td class="text-xs-center">{{ props.item.checkbox_multiple }}</td>
        
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'question',
      headers: [
        {
          text: 'Question',
          align: 'center',
          value: 'question'
        },
        {
          text: 'Question Type',
          align: 'center',
          sortable: false,
          value: 'question_types.ui_category_id'
        },
        {
          text: 'Question Variable',
          align: 'center',
          sortable: false,
          value: 'question_variable'
        },
         {
          text: 'Descriptions',
          align: 'center',
          sortable: false,
          value: 'description'
        },
         {
          text: 'Required/Optional',
          align: 'center',
          sortable: false,
          value: 'required_optional'
        },
         {
          text: 'Multiple answer(yes/no)',
          align: 'center',
          sortable: false,
          value: 'multiple_answer'
        },
         {
          text: 'Measurement Settings',
          align: 'center',
          sortable: false,
          value: 'measurement_settings'
        },
         {
          text: 'Checkbox multiple',
          align: 'center',
          sortable: false,
          value: 'checkbox_multiple'
        },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: { 
        question: '',
        question_type_id:'',
        question_variable: '',
        description: '',
        required_optional: '',
        multiple_answer: '',
        measurement_settings: '',
        checkbox_multiple: '',
      },
      defaultItem: {  
        question: '',
        question_type_id:'',
        question_variable: '',
        description: '',
        required_optional: '',
        multiple_answer: '',
        measurement_settings: '',
        checkbox_multiple: '',
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Question' : 'Edit Question'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // console.log(this.apiUrl);
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.datas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.datas.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.datas.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>